import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { base, baseSepolia } from 'wagmi/chains';

// Get network from environment variable
// REACT_APP_NETWORK=mainnet or REACT_APP_NETWORK=testnet
const network = process.env.REACT_APP_NETWORK || 'mainnet';
const isTestnet = network === 'testnet';
const chains = isTestnet ? [baseSepolia] : [base];

export const config = getDefaultConfig({
  appName: 'CVmesh',
  projectId: process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || 'd1e0acd8b2e7449b18a3d67f07eac043',
  chains: chains,
  ssr: false,
});

// Export network info for use in other components
export const networkConfig = {
  isTestnet,
  network,
  chainId: isTestnet ? baseSepolia.id : base.id,
  chainName: isTestnet ? 'Base Sepolia' : 'Base',
};

